import { ClientError, ServerError } from "@sanity/client";

/**
 * @internal
 */
export const isSanityClientError = (
  err: unknown,
): err is ClientError | ServerError =>
  err instanceof ClientError || err instanceof ServerError;
